// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2EHBJ","label":"Category_label__DT2Ef","content":"Category_content__U7yGu","header":"Category_header__1HmXH","location":"Category_location__UdOQT"};